import script from "./eFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./eFooter.vue?vue&type=script&lang=ts&setup=true"

import "./eFooter.vue?vue&type=style&index=0&id=3f4a79ec&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4a79ec"]])

export default __exports__